export default "__VITE_ASSET__CENK$Zqd__"